// PrivacyPage — renders docs/privacy.md as a public, no-auth page.
// Route: /privacy (public, outside RequireAuth)
import content from '../../../docs/privacy.md?raw';
import { Footer } from '../components/Footer';

export function PrivacyPage() {
  return (
    <div className="yg-prose-page">
      <div className="yg-prose-wrap">
        <span className="yg-prose-effective">Legal document</span>
        <h1>Privacy Policy</h1>
        <pre className="yg-prose-content">{content}</pre>
        <Footer />
      </div>
    </div>
  );
}
